module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedRegular.eot";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedRegular.eot
// module id = 1010
// module chunks = 19